export const serviceMenu: Array<{ id: string; label: string }> = [
  { id: "overview", label: "Overview" },
  { id: "insights", label: "Insights" },
  // { id: "updates", label: "Updates" },
  // { id: "checklists", label: "Checklists" },
  // { id: "discussion-form", label: "Discussion forum" },
];

export enum RecurringFrequency {
  MONTHLY = "monthly",
  QUARTERLY = "quarterly",
  HALF_YEARLY = "half_yearly",
  YEARLY = "yearly",
}

export enum DateTypes {
  START_DATE = "start_date",
  STATUTORY_DATE = "status_date",
  EXPECTED_DATE = "expected_date",
}

export enum DscApplicationStatus {
  APPLICATION_SUBMITTED = 'application_submitted',
  PENDING_AT_EMUDHRA = 'pending_at_emudhra',
  DSC_ISSUED = 'dsc_issued',
  NONE = 'NONE',
}

export enum FILETYPES {
  JPEG = "image/jpeg",
  PNG = "image/png",
  SVG = "image/svg+xml",
  JPG = "image/jpg",
  TEXT = "text/plain",
  CSV = "text/csv",
  MP4 = "video/mp4",
  AUDIO = "audio/mpeg",
  WEBM = "video/webm",
  PDF = "application/pdf",
  ZIP1 = "application/zip",
  ZIP2 = "application/vnd.android.package-archive",
  SHEET1 = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  SHEET2 = "application/vnd.oasis.opendocument.spreadsheet",
  SHEET3 = "application/vnd.ms-excel",
  SHEET4 = "application/vnd.google-apps.spreadsheet",
  DOC1 = "application/vnd.oasis.opendocument.text",
  DOC2 = "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  DOC3 = "application/msword",
  DOC4 = "application/vnd.google-apps.document",
  PRESENTATION1 = "application/vnd.oasis.opendocument.presentation",
  PRESENTATION2 = "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  PRESENTATION3 = "application/vnd.ms-powerpoint",
}